<template>
    <div>
        <div class="width100 vaarroute" @click="toggleInfoHarbour">
            <div class="col1">
                <span
                    v-bind:class="{
                        'nummer-vaarroute': index < 10,
                        'nummer-vaarroute2': index > 9,
                    }"
                    >{{ index }}</span
                >
            </div>

            <div class="col2">
                <p v-if="!port.true_id">
                    {{ port.haven_naam
                    }}<span v-if="port.land_naam">, {{ port.land_naam }}</span>
                </p>
              <p v-if="port.true_id">
                Geen haven gevonden
              </p>
            </div>
            <div class="col3">
                <p v-if="port.arrival">A: {{ port.arrival }}</p>
            </div>
            <div class="col3">
                <p v-if="port.departure">V: {{ port.departure }}</p>
            </div>
            <div class="col1">
                <font-awesome-icon
                    icon="plus"
                    class="icon-vaarroute"
                    v-if="port.omschrijving && !showMore"
                />
                <font-awesome-icon
                    icon="minus"
                    class="icon-vaarroute"
                    v-if="port.omschrijving && showMore"
                />
            </div>
        </div>
        <transition name="fade" mode="in-out" appear>
            <div class="portomschrijving" v-if="port.omschrijving && showMore">
                <p v-html="port.omschrijving"></p>
            </div>
        </transition>

        <button v-if="isOffice" @click="openPort" >
          Verander Haven
        </button>
    </div>
</template>

<script>
export default {
    name: 'CruiseItineraryDetail.vue',
    props: {
        port: Object,
        index: String,
        window: window,
        rederij_id: Number,
        cruise_id: Number,
    },
    data: function() {
        return {
            showMore: false,
        }
    },
    methods: {
        toggleInfoHarbour: function() {
            this.showMore = !this.showMore
        },
      openPort: function(){
          var port_id = this.port.true_id ? this.port.true_id : this.port.id;
          window.open('/backend3/predict_haven.php?id=' + port_id + '&rederij_id=' + this.rederij_id + '&cruise_id=' + this.cruise_id, '_blank');
      }
    },
    computed: {
      isOffice: function() {
        return this.$store.state.isKantoorIP
      },
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1024px) {
    .vaarroute {
        height: 40px;
    }
}
.vaarroute {
    min-height: 40px;
}
.width100 {
    width: initial;
    min-width: 100%;
    border-bottom: 1px dashed rgba(158, 158, 158, 0.4);
    display: flex;
}
.portomschrijving {
    width: initial;
    min-width: 100%;
    border-bottom: 1px dashed rgba(158, 158, 158, 0.4);
    display: flex;
    p {
        margin-left: 62px;

        padding-top: 5px;
        width: calc(100% - 62px);
    }
}
.nummer-vaarroute {
    background: #37b5d3;
    color: white;
    padding: 7px 11px 7px 12px;
    border-radius: 50%;
    font-weight: bold;
    width: 20px;
    height: 30px;
}
.nummer-vaarroute2 {
    background: #37b5d3;
    color: white;
    padding: 7px 8px 7px 8px;
    border-radius: 50%;
    font-weight: bold;
    width: 20px;
    height: 30px;
}
.icon-vaarroute {
    background: #37b5d3;
    color: white;
    padding: 7px 8px 7px 8px;
    border-radius: 50%;
    font-weight: bold;
    cursor: pointer;
    margin-top: -2px;
}
.col1 {
    padding: 10px;
    width: 40px;
}
.col2 {
    padding: 10px;
    min-width: 140px;

    width: calc(100% - 240px);
}
.col3 {
    padding: 10px;
    width: 80px !important;
    min-width: 80px !important;
}
</style>
